import { render, staticRenderFns } from "./CurrencyInputWidget.vue?vue&type=template&id=19f3262e&scoped=true"
import script from "./CurrencyInputWidget.vue?vue&type=script&lang=js"
export * from "./CurrencyInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f3262e",
  null
  
)

export default component.exports